import Topbar from './Topbar';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {
  errorToast,
  getPathForSurvey,
  isCopanySuperOrSubAdmin,
  isSuperAndSubAdmin,
  successToast
} from '../../utils/helper';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import AddSurveyPopup from '../../component/common/modals/CreatePopup';
import { surveyApi } from '../../api/surveyApi';
import SurveyCrad from './addSurvey/surveyCrad';
import Loader from '../../component/common/Loader';
import { StatCard, STAT_ICONS } from '../../component/common/designSystem';
import AdminDashboardInsight from './addSurvey/AdminDashboardInsight';
import B2BAdminDashboardInsight from './addSurvey/B2bAdminDashboardInsights';
import InfoPopup from '../../component/common/InfoPopup';
import { CompanyApi } from '../../api/companyApi';
import { set } from 'date-fns';
import { pulseSurveyPageData } from '../../utils/pageContent';

ChartJS.register(ArcElement, Tooltip, Legend);

const PulseSurveyDashboard = () => {
  const [isOpen, setIsOpen] = useState(false); //For Date created dropdown
  const [open, setOpen] = useState(false);

  const [Id, setId] = useState('');

  const [isPopupOpen, setIsPopupOpen] = useState(false); // For Survey popup
  const [isB2B, setIsB2B] = useState(false);
  const [survey, setSurvey] = useState([]);
  const [info, setInfo] = useState(null);

  const [templateData, setTemplateData] = useState([]);

  const [selectedOption, setSelectedOption] = useState('Date Created'); // Manage selected option for Date created dropdown

  const [loading, setLoading] = useState(false);

  const popupOption = ['Survey', 'Template']; // Options for popup

  const [resultData, setResultData] = useState();

  const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));

  const navigate = useNavigate();

  let isAdmin;
  isAdmin =
    userType === 0 || userType === 1 ? true : userType === 3 || userType === 4 ? false : true;

  // Function to toggle dropdown For Date created
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev); // Toggle isOpen state
  };

  // Function to toggle popup
  const togglePopUp = () => {
    if (isAdmin) {
      setIsPopupOpen((prev) => !prev);
    } else {
      setIsB2B((prev) => !prev);
    }
  };

  // Function to handle option click For Date created button
  const handleOptionClick = (option) => {
    setSelectedOption(option); // Set the clicked option as selected
    setIsOpen(false); // Close the dropdown
  };

  // Function to handle option click For Survey popup
  const handlePopuopOptionClick = (option) => {
    setIsPopupOpen(false); // Close the dropdown
    setIsB2B(false);
    localStorage.setItem('surveyType', option);
    localStorage.removeItem('surveyId');
  };

  const handleQuestionAction = (id) => {
    if (Id === '') {
      setId(id);
    } else {
      setId('');
    }
  };

  const fetchSurvey = async () => {
    try {
      const userType = JSON.parse(localStorage.getItem('userData'))?.userType;

      let response;

      if (userType === 0 || userType === 1) {
        response = await surveyApi.getSurveys(1, 6, undefined, 2, '', '', '');
      } else if (userType === 3 || userType === 4) {
        response = await surveyApi.getSurveyAll(1, 6, undefined, 2, '', '', undefined);
      } else {
        console.log('Invalid userType');
        return;
      }

      setSurvey(response?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchInfo = async () => {
    if (userType === 4 || userType === 3) {
      try {
        const response = await CompanyApi.getInfoData('pulse_survey');
        if (response?.data?.meta?.code === 200) {
          if (response?.data?.data?.tutorialsData?.length > 0) {
            setOpen(true);
            setInfo(response?.data?.data);
          } else {
            setOpen(false);
            errorToast(pulseSurveyPageData.tutorialNotFoundMessage);
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const fetchSurveyStatus = async () => {
    if (isCopanySuperOrSubAdmin()) {
      // true for B2B admin
      try {
        await surveyApi
          .getSurveyStatus(false, companyId)
          .then((response) => {
            console.log('136 response?.data?.data', response?.data?.data);
            setResultData(response?.data?.data);
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else if (isSuperAndSubAdmin()) {
      try {
        await surveyApi
          .getSurveyStatus(true, '')
          .then((response) => {
            console.log('150 response?.data?.data', response?.data?.data);
            setResultData(response?.data?.data);
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const fetchTemplate = async () => {
    setLoading(true);
    try {
      const userType = JSON.parse(localStorage.getItem('userData'))?.userType;

      let response;

      if (userType === 0 || userType === 1) {
        response = await surveyApi.getSurveys(1, 6, undefined, 1, '', '', '');
      } else if (userType === 3 || userType === 4) {
        response = await surveyApi.getSurveyAll(1, 6, undefined, 1, 5, '', undefined);
      } else {
        console.log('Invalid userType');
        return;
      }

      setTemplateData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSurvey();
    fetchTemplate();
    fetchSurveyStatus();
  }, []);

  const handleDeletePulseSurve = (assessmentId, type) => {
    surveyApi
      .deleteSurvey(assessmentId, isAdmin)
      .then((response) => {
        console.log(response);
        if (response?.data?.meta?.code === 200) {
          successToast(response?.data?.meta?.message);
          type === 'survey' ? fetchSurvey() : fetchTemplate();
          fetchSurveyStatus();
        }
      })
      .catch((error) => {
        console.log(error);
        errorToast(
          error?.response?.data?.message ?? pulseSurveyPageData.unknownErrorOccuredMessage
        );
      });
  };

  const handleDeactivatePulseSurvey = (assessmentId, type) => {
    surveyApi
      .inactiveAdminSurvey(assessmentId, isAdmin)
      .then((response) => {
        if (response?.data?.meta?.code === 200) {
          successToast(response?.data?.meta?.message);
          type === 'survey' ? fetchSurvey() : fetchTemplate();
          fetchSurveyStatus();
        }
      })
      .catch((error) => {
        console.log(error);
        errorToast(
          error?.response?.data?.message ?? pulseSurveyPageData.unknownErrorOccuredMessage
        );
      });
  };

  const handleCopyPulseSurvey = (assessmentId, type) => {
    const body = { id: assessmentId };
    surveyApi
      .copySurvey(body, isAdmin)
      .then((response) => {
        if (response?.data?.meta?.code === 200) {
          successToast(response?.data?.meta?.message);
          type === 'survey' ? fetchSurvey() : fetchTemplate();
          fetchSurveyStatus();
        }
      })
      .catch((error) => {
        console.log(error);
        errorToast(
          error?.response?.data?.message ?? pulseSurveyPageData.unknownErrorOccuredMessage
        );
      });
  };

  const AdminStatusCards = [
    <StatCard
      icon={STAT_ICONS.catalog}
      title={pulseSurveyPageData.createdSurveysLabel}
      value={resultData?.totalSurveys ? resultData.totalSurveys : 0}
    />,
    <StatCard
      icon={STAT_ICONS.onlineNow}
      title={pulseSurveyPageData.activeSurveysLabel}
      value={resultData?.publishedSurveys ? resultData?.publishedSurveys : 0}
    />,
    <StatCard
      icon={STAT_ICONS.completions}
      title={pulseSurveyPageData.completedSurveysLabel}
      value={resultData?.completedSurveys ? resultData.completedSurveys : 0}
    />,
    <StatCard
      icon={STAT_ICONS.score}
      title={pulseSurveyPageData.responseRateLabel}
      value={resultData?.completionRate ? resultData?.completionRate : 0}
    />
  ];

  const subAdminStatusCards = [
    <StatCard
      icon={STAT_ICONS.catalog}
      title={pulseSurveyPageData.createdSurveysLabel}
      value={resultData?.createdSurveys ? resultData.createdSurveys : 0}
    />,
    <StatCard
      icon={STAT_ICONS.onlineNow}
      title={pulseSurveyPageData.activeSurveysLabel}
      value={resultData?.activeSurveys ? resultData.activeSurveys : 0}
    />,
    <StatCard
      icon={STAT_ICONS.completions}
      title={pulseSurveyPageData.completedSurveysLabel}
      value={resultData?.completedSurveys ? resultData.completedSurveys : 0}
    />,
    <StatCard
      icon={STAT_ICONS.score}
      title={pulseSurveyPageData.responseRateLabel}
      value={resultData?.responseRate ? resultData.responseRate : 0}
    />
  ];

  const dashborStatusCardList = isSuperAndSubAdmin() ? AdminStatusCards : subAdminStatusCards;

  return (
    <div className="mx-auto max-w-[1640px] overflow-x-hidden hide-scrollbar font-work-sans">
      {loading && <Loader />}
      <div className="font-work-sans lg:ps-5">
        <Topbar
          title={pulseSurveyPageData.pageTitle}
          infoBtn={true}
          setOpen={setOpen}
          fetchInfo={fetchInfo}
        />
        {/* Top buttons */}
        <div className="flex sm:justify-end items-center lg:mt-[40px]">
          <div className="flex flex-wrap items-center gap-3">
            <div
              className="flex flex-row relative justify-center items-center w-full sm:w-[195px] sm:p-0 px-4 h-[40px] bg-[#1F1F1F] text-[16px] rounded-[100px] text-[#F4F4F4] cursor-pointer"
              onClick={togglePopUp}
            >
              <button className="flex flex-row items-center" type="button">
                {pulseSurveyPageData.createNewSurveyBtnText}
              </button>
              {isB2B && (
                <AddSurveyPopup
                  open={isB2B}
                  setOpen={togglePopUp}
                  popupOption={popupOption}
                  path1={getPathForSurvey('/pulse-survey/add-edit-survey')}
                  path2={getPathForSurvey('/pulse-survey/my-survey?type=1')}
                  popupHeading={pulseSurveyPageData.createNewSurveyPopUp.heading}
                  handlePopuopOptionClick={handlePopuopOptionClick}
                  firstTitle={pulseSurveyPageData.createNewSurveyPopUp.startFromScratch.title}
                  firstSubtitle={
                    pulseSurveyPageData.createNewSurveyPopUp.startFromScratch.description
                  }
                  secondTitle={pulseSurveyPageData.createNewSurveyPopUp.useATemplate.title}
                  secondSubTitle={pulseSurveyPageData.createNewSurveyPopUp.useATemplate.description}
                />
              )}
              {isPopupOpen && (
                <AddSurveyPopup
                  open={isPopupOpen}
                  setOpen={togglePopUp}
                  popupOption={popupOption}
                  path1={getPathForSurvey('/pulse-survey/add-edit-survey')}
                  path2={getPathForSurvey('/pulse-survey/add-edit-survey')}
                  popupHeading={pulseSurveyPageData.createNewSurveyPopUp.heading}
                  handlePopuopOptionClick={handlePopuopOptionClick}
                  firstTitle={pulseSurveyPageData.createNewSurveyPopUp.createNewSurvey.title}
                  firstSubtitle={
                    pulseSurveyPageData.createNewSurveyPopUp.createNewSurvey.description
                  }
                  secondTitle={pulseSurveyPageData.createNewSurveyPopUp.createNewTemplate.title}
                  secondSubTitle={
                    pulseSurveyPageData.createNewSurveyPopUp.createNewTemplate.description
                  }
                />
              )}
            </div>
          </div>
        </div>

        {/* Slide */}
        <div className="grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 h-auto gap-4 mt-5">
          {AdminStatusCards.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>

        {/* My Recent Surveys */}
        <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
          <div className="flex flex-row justify-between mb-8 items-center">
            <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
              {pulseSurveyPageData.myRecentSurveyText}
            </p>
            <Link
              to={getPathForSurvey('/pulse-survey/my-survey?type=2')}
              className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-active"
            >
              {pulseSurveyPageData.viewAllBtnText}
            </Link>
          </div>
          <div className="h-fit gap-x-4 gap-y-6 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
            {survey?.slice(0, 6)?.map((item, index) => (
              <SurveyCrad
                key={index}
                item={item}
                handleQuestionAction={(id) => handleQuestionAction(id)}
                setId={setId}
                Id={Id}
                handleDeletePulseSurve={(deleteId) => handleDeletePulseSurve(deleteId, 'survey')}
                handleCopyPulseSurvey={(copyId) => handleCopyPulseSurvey(copyId, 'survey')}
                handleDeactivatePulseSurvey={(deactivateId) =>
                  handleDeactivatePulseSurvey(deactivateId, 'survey')
                }
              />
            ))}
          </div>
        </div>

        {/* My Template */}
        <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl mt-5 lg:mb-10 lg:p-6 p-4 pb-8">
          <div className="flex flex-row justify-between mb-8 items-center">
            <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
              {pulseSurveyPageData.myTempletesText}
            </p>
            <Link
              to={getPathForSurvey('/pulse-survey/my-survey?type=1')}
              className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-active"
            >
              {pulseSurveyPageData.viewAllBtnText}
            </Link>
          </div>
          <div className="h-fit gap-x-4 gap-y-6 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor border-shoorah-borderGray rounded-2xl">
            {templateData?.slice(0, 6)?.map((item, index) => (
              <SurveyCrad
                key={index}
                item={item}
                handleQuestionAction={(id) => handleQuestionAction(id)}
                Id={Id}
                setId={setId}
                handleDeletePulseSurve={(deleteId) => handleDeletePulseSurve(deleteId, 'template')}
                isAdmin={isAdmin}
                handleCopyPulseSurvey={(copyId) => handleCopyPulseSurvey(copyId, 'template')}
                handleDeactivatePulseSurvey={(deactivateId) =>
                  handleDeactivatePulseSurvey(deactivateId, 'template')
                }
              />
            ))}
          </div>
          {/* admin chart */}
        </div>

        {isSuperAndSubAdmin() ? (
          <>
            <div className="flex flex-col h-full lg:mb-10">
              <AdminDashboardInsight resultData={resultData} />
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col h-full lg:mb-10">
              <B2BAdminDashboardInsight resultData={resultData} />
            </div>
          </>
        )}
      </div>
      <InfoPopup
        open={open}
        data={info}
        title={pulseSurveyPageData.pageTitle}
        handleClose={() => setOpen(false)}
      />
    </div>
  );
};
export default PulseSurveyDashboard;
